module.exports = __webpack_public_path__ + "img/zigatext-white-icon.4098863d.png";